import { render, staticRenderFns } from "./Patent.vue?vue&type=template&id=22353a7a&scoped=true"
import script from "./Patent.vue?vue&type=script&setup=true&lang=js"
export * from "./Patent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Patent.vue?vue&type=style&index=0&id=22353a7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22353a7a",
  null
  
)

export default component.exports